import { createDomain, sample } from 'effector'
import { driverModel } from '~/entities/Driver'
import { featureFlagModel } from '~/shared/lib/featureFlag'

const domain = createDomain('entities.driverEmail.addEmailDrawer')

export const openAddEmailDrawer = domain.createEvent()
export const closeAddEmailDrawer = domain.createEvent()

export const $isAddEmailDrawerOpen = domain
  .createStore<boolean>(false)
  .on(openAddEmailDrawer, () => true)
  .on(closeAddEmailDrawer, () => false)

const $hasBeenOpened = domain
  .createStore(false)
  .on(openAddEmailDrawer, () => true)

sample({
  clock: driverModel.getDriverFx.doneData,
  source: {
    featureFlags: featureFlagModel.$featureFlags,
    hasBeenOpened: $hasBeenOpened,
  },
  filter: ({ featureFlags, hasBeenOpened }, driver) =>
    !!driver &&
    featureFlags.add_email_drawer &&
    !driver.getIsLead() &&
    !driver.getEmail() &&
    !hasBeenOpened,
  target: openAddEmailDrawer,
})
